import Article from "~/models/article";
import Label from "~/models/label";

// Type for YAML-based collections
export interface YamlCollection {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  items?: any[];
  labels?: any[];
}

export default class Collection {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  items: Article[];
  labels: Label[];

  constructor(collection: YamlCollection) {
    this.id = collection.id;
    this.slug = collection.slug!;
    this.title = collection.title!;
    this.subtitle = collection.subtitle!;
    this.items = collection.items?.map((item: any) => new Article(item!)) || [];
    this.labels =
      collection.labels?.map((label: any) => new Label(label!)) || [];
  }
}
